import React, { useState, useEffect } from 'react'
import { SelectBox } from '@tecuity/granite-ui'
import './CustomCorrespondenceOptions.scss'
import { useDispatch } from 'react-redux'
import * as api from 'requests'
import { SET_SETTINGS_LIST } from '../../SettingsReducer'
import { useSelector, shallowEqual } from 'react-redux'
import { SET_DETAIL_CONFIG_SOURCE_TYPE } from '../../SettingsReducer'
import './SignerCapacityTypesOptions.scss'
import { Spinner } from 'components/Loaders/Loaders'

const SignerCapacityTypesOptions = () => {
  const dispatch = useDispatch()
  const { optionalData } = useSelector((state) => state.settings, shallowEqual)
  const [sourceTypeOptions, setSourceTypeOptions] = useState([])
  const [loading, setLoading] = useState(false);
  const [sourceType, setSourceType] = useState(optionalData.sourceType || 0)

  useEffect(() => {
    api.GET_SIGNER_CAPACTITY_TYPES_SETTINGS(
      sourceType,
      res => {
        dispatch({
          type: SET_SETTINGS_LIST,
          settingsList: res
            .map((item) => ({
              ...item,
              Id: item.Id,
              Name: item.Name,
            }))
            .sort((a, b) => (a.Name > b.Name ? 1 : -1)),
        })
        setLoading(false)
      },
      err => {
        console.error('retrieving', err)
        setLoading(false)
      }
    )

    
  }, [sourceType])

  useEffect(() => {
    setLoading(true)
    api.GET_SOURCE_TYPE_OPTIONS(
      (res) => {
        if (res) {
          const options = [
            ...res
              .map((t) => ({
                value: t.Id,
                label: t.Name.trim(),
                moduleName: t.ModuleName,
              }))
              .sort((a, b) => (a.label > b.label ? 1 : -1)),
          ]
          setSourceTypeOptions(options)
          dispatch({ type: SET_DETAIL_CONFIG_SOURCE_TYPE, sourceType: options[0].value.toString() })
          setLoading(false)
        }
      },
      (err) => {
        console.error(err.message)
        setLoading(false)
      }
    )
  }, [])

  return (
    <div className="signer-capacity-type-options">
      <SelectBox
            label="Source Type"
            noPlaceholder
            value={sourceType}
            onChange={(val) => {
              setSourceType(val)
            }}
            options={sourceTypeOptions}
          />
        {loading && (
        <div className="type-loader">
          <Spinner size="small" themeColor="dark-neutral" />
        </div>
      )}
    </div>
  )
}

export default SignerCapacityTypesOptions
